// Offline-MODUS der App — bewusst KEIN Live-Netzstatus (kein Hin-und-Her bei wackeliger Verbindung).
//
//   ONLINE ──(erster Netzwerkfehler/Timeout, Browser-'offline'-Event)──▶ OFFLINE
//   OFFLINE ──(nur: App-Neustart/Reload oder reconnect() mit erfolgreicher Probe)──▶ ONLINE
//
// Eintritt meldet der API-Interceptor (components/wrapper/API.js) zentral. Ein erfolgreicher Request
// schaltet NIE automatisch zurück; das Browser-'online'-Event wird ignoriert (kommt oft verfrüht).
// Im Offline-Modus lehnt der API-Interceptor jeden Request sofort ab (außer der Verbindungsprobe).

// Startwert: Browser meldet offline ODER der Service Worker hat die App-Shell aus dem Cache gebootet, weil
// das Netz nicht rechtzeitig antwortete (Marker-Meta, siehe public/service-worker.js).
function startsOffline() {
  if (typeof navigator !== 'undefined' && 'onLine' in navigator && !navigator.onLine) return true;
  return typeof document !== 'undefined' && !!document.querySelector('meta[name="aveorga-offline-boot"]');
}

let offline = startsOffline();
const listeners = new Set();

function emit() {
  for (const cb of listeners) {
    try { cb(offline); } catch (e) { /* ignore */ }
  }
}

export function isOffline() {
  return offline;
}

export function enterOffline() {
  if (offline) return;
  offline = true;
  emit();
}

// Nur nach bestätigter Verbindung aufrufen (offlineApi.reconnect).
export function leaveOffline() {
  if (!offline) return;
  offline = false;
  emit();
}

export function subscribeConnectivity(cb) {
  listeners.add(cb);
  return () => { listeners.delete(cb); };
}

if (typeof window !== 'undefined') {
  window.addEventListener('offline', enterOffline);
}
